$('.home-testimonials-slides-list').slick({
  fade: true,
  arrows: false,
  dots: true
})

$('.the-machine-testimonials ul').slick({   
  infinite: true,
  speed: 500,
  cssEase: 'linear',
  autoplay: true,
  speed: 1000,
  slidesToShow: 4,
  centerMode: true,
  arrows: false,
  centerPadding: '60px',
  responsive: [       
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

if($('.machin-scroll-banner').length > 0){
  $(window).on('scroll', function(){
// 	console.log($('.ms-content').offset().top,$(window).scrollTop(),'>>', $('.ms-content').offset().top - $(window).scrollTop())
      var ra = 1 - (($('.ms-content').offset().top - $(window).scrollTop())/1000);
      if(ra > 0 && ra < 0.5){
          $('.ms-image span').css('opacity',  ra);
      }	
  });
} 